module.exports = __webpack_public_path__ + "static/media/1019705.555220ab.jpg";